class HttpResponse {
  constructor(response, data) {
    this.status = response.status
    this.statusText = response.statusText
    this.ok = response.ok
    this.headers = response.headers
    this.body = data
    this.data = data
    this.json = () => Promise.resolve(data)
    this.text = () => Promise.resolve(typeof data === 'string' ? data : JSON.stringify(data))
  }
}

class Http {
  constructor() {
    this.interceptors = []
  }

  _buildOptions(options = {}) {
    const defaultHeaders = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }

    return {
      ...options,
      headers: {
        ...defaultHeaders,
        ...options.headers,
      },
      credentials: options.credentials || 'same-origin',
    }
  }

  async _processResponse(response) {
    let data
    const contentType = response.headers.get('content-type')

    if (contentType && contentType.includes('application/json')) {
      data = await response.json()
    } else {
      data = await response.text()
    }

    const httpResponse = new HttpResponse(response, data)

    if (!response.ok) {
      const error = new Error(response.statusText)
      error.response = httpResponse
      error.status = response.status
      error.body = data
      throw error
    }

    return httpResponse
  }

  async get(url, options = {}) {
    const fetchOptions = this._buildOptions({
      ...options,
      method: 'GET',
    })

    const response = await fetch(url, fetchOptions)
    return this._processResponse(response)
  }

  async post(url, data = null, options = {}) {
    const fetchOptions = this._buildOptions({
      ...options,
      method: 'POST',
      body: data ? JSON.stringify(data) : undefined,
    })

    const response = await fetch(url, fetchOptions)
    return this._processResponse(response)
  }

  async put(url, data = null, options = {}) {
    const fetchOptions = this._buildOptions({
      ...options,
      method: 'PUT',
      body: data ? JSON.stringify(data) : undefined,
    })

    const response = await fetch(url, fetchOptions)
    return this._processResponse(response)
  }

  async delete(url, options = {}) {
    const fetchOptions = this._buildOptions({
      ...options,
      method: 'DELETE',
    })

    const response = await fetch(url, fetchOptions)
    return this._processResponse(response)
  }

  async patch(url, data = null, options = {}) {
    const fetchOptions = this._buildOptions({
      ...options,
      method: 'PATCH',
      body: data ? JSON.stringify(data) : undefined,
    })

    const response = await fetch(url, fetchOptions)
    return this._processResponse(response)
  }

  async head(url, options = {}) {
    const fetchOptions = this._buildOptions({
      ...options,
      method: 'HEAD',
    })

    const response = await fetch(url, fetchOptions)
    return this._processResponse(response)
  }

  async options(url, options = {}) {
    const fetchOptions = this._buildOptions({
      ...options,
      method: 'OPTIONS',
    })

    const response = await fetch(url, fetchOptions)
    return this._processResponse(response)
  }
}

export { Http, HttpResponse }

export const http = new Http()
